import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useTheme } from "@mui/material";
import Slide from "./Slide";

import { tss } from 'tss-react';

export default function Slider() {
  const theme = useTheme();
  const { classes } = tss.create(theme.customComponents.slider.styles)();

  return (
    <div className={classes.root}>
      <Carousel autoPlay showArrows={false} showThumbs={false} showStatus={false} infiniteLoop={true} interval={10000}>
        {theme.customComponents.slider.content.map((each) => <Slide {...each} key={each.label} />)}
      </Carousel>
    </div>
  )
}
